import classNames from 'classnames';

import styles from './Preloader.module.scss';

interface Props {
    theme?: PreloaderTheme;
    modifiers?: PreloaderModifiers[];
}

export enum PreloaderTheme {
    // @ts-ignore
    Grey = styles.grey,
    // @ts-ignore
    Blue = styles.blue,
}

export enum PreloaderModifiers {
    // @ts-ignore
    Small = styles.small,
    // @ts-ignore
    Tiny = styles.tiny,
    // @ts-ignore
    Big = styles.big,
}

export function Preloader(props?: Props) {
    return (
        <div
            id="preloader"
            className={classNames([styles.root, props?.theme ?? {}, ...(props?.modifiers ?? [])])}
        >
            <div className={styles.element} />
            <div className={styles.element} />
            <div className={styles.element} />
            <div className={styles.element} />
            <div className={styles.element} />
            <div className={styles.element} />
            <div className={styles.element} />
            <div className={styles.element} />
        </div>
    );
}
